// Polyfills
import 'core-js/es/array/at'

import initializeExternalApi from 'lib/external-api/initialize-api'

// Used by: Client
export { useConfig as useSeamlyConfig } from 'domains/config/hooks'
export {
  useTranslatedEventData,
  useTranslations,
  useTranslationsContainer,
} from 'domains/translations/hooks'
export { visibilityStates } from 'domains/visibility/constants'
export { useVisibility as useSeamlyVisibility } from 'domains/visibility/hooks'
export { useChoicePrompt } from 'ui/components/conversation/event/choice-prompt'
export { useSeamlyActions } from 'ui/hooks/use-seamly-actions'
export { eventTypes } from 'ui/utils/seamly-utils'
export { default as API } from 'api'
export { randomId } from 'lib/id'
export { useI18n } from 'domains/i18n/hooks'

// Used by: StyleGuide
export { calculateVisibility } from 'domains/visibility/utils'
export { Provider as SeamlyStoreProvider } from 'react-redux'
export {
  SeamlyApiContext,
  SeamlyEventBusContext,
} from 'ui/components/core/seamly-api-context'
export { SeamlyLiveRegionContext } from 'ui/components/core/seamly-live-region-context'
export { className } from 'lib/css'
export {
  useEvents,
  useGeneratedId,
  useSeamlyChat,
  useSeamlyCommands,
  useSeamlyEventStream,
  useSeamlyIdleDetachCountdown,
  useSeamlyMessageContainerClassNames,
  useSeamlyOptions,
} from 'ui/hooks/seamly-hooks'
// Used by: Demo
export { default as EventParticipant } from 'ui/components/conversation/event/event-participant'
export { default as appStorageProvider } from 'lib/store/providers/app-storage'
export { default as cookieStorageProvider } from 'lib/store/providers/cookie-storage'
export { default as sessionStorageProvider } from 'lib/store/providers/session-storage'

// Used by: Client
export { default as ComponentFilter } from 'ui/components/conversation/component-filter'
export { default as Conversation } from 'ui/components/conversation/conversation'
export { default as Text } from 'ui/components/conversation/event/text'
export { default as MessageContainer } from 'ui/components/conversation/message-container'
export { default as EntryContainer } from 'ui/components/entry/entry-container'
export { default as TextEntry } from 'ui/components/entry/text-entry'
export { default as Upload } from 'ui/components/entry/upload'
export { default as AgentInfo } from 'ui/components/layout/agent-info'
export { default as Chat } from 'ui/components/layout/chat'
export { default as ChatFrame } from 'ui/components/layout/chat-frame'
export { default as Header } from 'ui/components/layout/header'
export { default as Icon } from 'ui/components/layout/icon'
export { default as Interrupt } from 'ui/components/layout/interrupt'

// Used by: StyleGuide
export { default as View } from 'ui/components/view' // Used by: Client (with custom view)
export { default as SeamlyGeneralError } from 'api/errors/seamly-general-error'
export { default as SeamlyOfflineError } from 'api/errors/seamly-offline-error'
export { default as Engine } from 'lib/engine'
export { default as ExternalApi } from 'lib/external-api'
export { default as SeamlyFileUpload } from 'ui/components/core/seamly-file-upload'
export { default as SeamlyActivityMonitor } from 'ui/components/core/seamly-activity-monitor'
export { default as SeamlyActivityEventContext } from 'ui/components/core/seamly-activity-event-context'
export { timeout } from 'ui/hooks/focus-helper-hooks'

export { default as appReducer } from 'domains/app/slice'
export {
  default as configReducer,
  setConfig,
  setPreChatEvents,
} from 'domains/config/slice'
export { default as formsReducer } from 'domains/forms/slice'
export type { I18nState } from 'domains/i18n/i18n.types'
export {
  default as i18nReducer,
  setInitialLocale,
  setTranslations,
} from 'domains/i18n/slice'
export { default as interruptReducer } from 'domains/interrupt/slice'
export { default as stateReducer, setParticipant } from 'domains/store/slice'
export type {
  MessageParticipant,
  StoreState,
  ReduxStore,
} from 'domains/store/store.types'
export { default as translationReducer } from 'domains/translations/slice'
export { default as visibilityReducer } from 'domains/visibility/slice'
export {
  getSearchParamsByKeys,
  getUrlSearchParams,
  getUrlSearchString,
  initResetSearchParams,
  replaceSearchParams,
} from 'lib/url-helpers'

// Used by: Client
export default initializeExternalApi
